module.exports = __webpack_public_path__ + "static/img/9.67a9e05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/2/9.png
// module id = Ps2E
// module chunks = 0